import type { AxiosRequestConfig, AxiosResponse, Axios, AxiosPromise, AxiosError } from 'axios'

export interface GAxiosResponse extends AxiosResponse  {
  config: GAxiosOptions
}

export type XhtInstance = {
  /**
   * @Author      gx12358
   * @DateTime    2023/1/6
   * @lastTime    2023/1/6
   * @description 请求之前处理config
   */
  beforeRequestHook?: (config: GAxiosOptions) => GAxiosOptions;

  /**
   * @description: 处理响应数据
   */
  transformResponseHook?: (res: GAxiosResponse, options: GAxiosOptions) => any;

  /**
   * @description: 请求失败处理
   */
  requestCatchHook?: (e: Error) => boolean;

  /**
   * @description: 请求之前的拦截器
   */
  requestInterceptors?: (config: GAxiosOptions) => GAxiosOptions;

  /**
   * @description: 请求之后的拦截器
   */
  responseInterceptors?: (res: GAxiosResponse) => GAxiosResponse;

  /**
   * @description: 请求之前的拦截器错误处理
   */
  requestInterceptorsCatch?: (error: AxiosError) => void;

  /**
   * @description: 请求之后的拦截器错误处理
   */
  responseInterceptorsCatch?: (axiosInstance: GAxiosInstance, error: AxiosError) => void;
}

export interface GAxiosOptions extends AxiosRequestConfig {
  headers?: Recordable;
  isMock?: boolean; // 是否是mock
  isReturnNativeResponse?: boolean; // 直接返回response，不作任何处理（包含响应值等基本信息）
  customize?: boolean; // 直接返回response.data（接口返回值），错误不做统一提示
  carryToken?: boolean; // 是否携带token
  prefix?: string; // 接口自定义前缀
  ignoreCancelToken?: boolean; // 忽略重复请求
  /**
   * @Author      gx12358
   * @DateTime    2023/1/6
   * @lastTime    2023/1/6
   * @description 请求之前处理config
   */
  beforeRequestHook?: XhtInstance['beforeRequestHook'];

  /**
   * @description: 处理响应数据
   */
  transformResponseHook?: XhtInstance['transformResponseHook'];

  /**
   * @description: 请求失败处理
   */
  requestCatchHook?: XhtInstance['requestCatchHook'];

  /**
   * @description: 请求之前的拦截器
   */
  requestInterceptors?: XhtInstance['requestInterceptors'];

  /**
   * @description: 请求之后的拦截器
   */
  responseInterceptors?: XhtInstance['responseInterceptors'];

  /**
   * @description: 请求之前的拦截器错误处理
   */
  requestInterceptorsCatch?: XhtInstance['requestInterceptorsCatch'];

  /**
   * @description: 请求之后的拦截器错误处理
   */
  responseInterceptorsCatch?: XhtInstance['responseInterceptorsCatch'];
}

export interface GAxiosInstance extends Axios {
  (config: GAxiosOptions): AxiosPromise<ResponseResult>;

  (url: string, config?: GAxiosOptions): AxiosPromise<ResponseResult>;
}

/**
 * @description: request method
 */
export enum RequestEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

/**
 * @description:  contentType
 */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
}

